import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import { Card } from 'react-bootstrap';
import { getAssignProducts } from '../services/po.stock.service';
import { formatDateToIST } from 'helpers/dateFormater';
import React from 'react';
import { AssignProductActionBtn } from './AssignProductActionBtn';


const AssignProducts = () => {
    const HasPermission = useHasPermission()

    const dataSource = React.useMemo(() => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const { searchValue } = loadOptions;
                    const parameterList = new URLSearchParams();
                    const search = JSON.parse(JSON.stringify(loadOptions));

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    const response = await getAssignProducts(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    }, []);



    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">Assigned Products</h5>
                        </Card.Header>
                        <Card.Body>
                            {HasPermission("ItemMaster.Read") ? (
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    width={"100%"}
                                    columnAutoWidth={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >

                                    <Pager
                                        showPageSizeSelector
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons
                                        displayMode="full"
                                        showInfo
                                    />

                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />

                                    <Summary>
                                        <TotalItem />
                                    </Summary>

                                    <Paging defaultPageSize={10} />
                                    <Column dataField="id" dataType="number" sortOrder="desc" width={150} visible={false} />
                                    <Paging defaultPageSize={10} />

                                    <Column
                                        allowFiltering={false}
                                        caption="Action"
                                        cssClass="text-center"
                                        width={150}
                                        cellRender={({ data }) => (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <AssignProductActionBtn
                                                    selectedId={data.id as string}
                                                />
                                            </div>
                                        )}
                                    />

                                    <Column
                                        dataField="invoiceNo"
                                        caption="Invoice No."
                                        dataType="string"
                                        cssClass='text-center'
                                    />
                                    <Column
                                        dataField="storeName"
                                        caption="Store Name"
                                        dataType="string"
                                        cssClass='text-center'
                                    />

                                    <Column
                                        dataField="productQty"
                                        caption="Quantity"
                                        cssClass='text-center'
                                        dataType="number"
                                    />

                                    <Column
                                        dataField="assignmentDate"
                                        caption="Assignment Date"
                                        dataType="datetime"
                                        cssClass='text-center'
                                        format="dd/MM/yyyy"
                                    />

                                    <Column
                                        dataField="createdOn"
                                        caption="Created On"
                                        cssClass='text-center'
                                        dataType="string"
                                        allowFiltering={false}
                                        calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)}
                                    />

                                </DataGrid>
                            ) : null}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default AssignProducts